import {LogLevel, PassedInitialConfig} from 'angular-auth-oidc-client';

export const authConfig: PassedInitialConfig = {
    config: {
        authority: 'https://auth.masasana.ai/realms/freymut',
        redirectUrl: window.location.origin + '/login',
        postLogoutRedirectUri: window.location.origin,
        clientId: 'lernplattform-frontend',
        scope: 'openid profile email roles offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        ignoreNonceAfterRefresh: true,
        triggerRefreshWhenIdTokenExpired: true,
        logLevel: LogLevel.Warn,
    }
}